import React from "react"

import { Button } from "components/Button"
import PharmaSupportContact from "components/PharmaSupportContact/PharmaSupportContact"
import PreviousButton from "components/Previous/PreviousButton"
import { Title } from "components/Title/Title"
import { useLanguage } from "locales"

import styles from "../PharmacyOwnerInfo/PharmacyOwnerInfo.module.scss"

// "Autres réglages" menu of the "Espace professionnel" modal: MSS preference and téléexpertise
const SettingsMenu: React.FC<{ onBack: () => void; onMss: () => void; onTeleexpertise: () => void }> = ({
  onBack,
  onMss,
  onTeleexpertise,
}) => {
  const { languages } = useLanguage()
  return (
    <>
      <PreviousButton onClick={onBack} />
      <Title text={<>{languages.otherSettingsCta.toUpperCase()}</>} style={{ marginTop: 80 }} />
      <div className={styles.MenuButtons}>
        <Button className={styles.MenuButton} onClick={onMss}>
          {languages.settingsMssCta.toUpperCase()}
        </Button>
        <Button className={styles.MenuButton} onClick={onTeleexpertise}>
          {languages.teleexpertiseCta.toUpperCase()}
        </Button>
      </div>
      <PharmaSupportContact />
    </>
  )
}

export default SettingsMenu
